export default __webpack_public_path__ + "static/media/img_23.42b14cc8.jpg";